<template>
    <div class="card" :class="{shadowy, 'sub-title': subTitle}">
        <div class="head" @click="clicked($event)">
            <slot name="head" @click="clicked($event)">
            </slot>
        </div>
        <div class="body" :class="{active: open}">
            <slot name="body">
            </slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'accordion',
  props: { shadowy: false, subTitle: false },
  mounted () {
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
  },
  methods: {
    clicked (event) {
      this.open = event.isTrusted ? !this.open : true
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/accordion.vue